import { render } from "./BtcWallet.vue?vue&type=template&id=7052b31b&ts=true"
import script from "./BtcWallet.vue?vue&type=script&lang=ts"
export * from "./BtcWallet.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__